import parse from './parser.js'
import { nest } from 'd3-collection'
import buildCreatable from './build-creatable'

/*
 * Generates a list of options that will be displayed in the menu
 */
export default function (data, node, highlightable) {
  if (data._refreshOptions || !data.options) {
    data.options = data._options || parse(node.node())
    delete data._refreshOptions
  }

  var opts = data.options

  if (typeof data.filter === 'function') {
    if (data.searchTerm) {
      opts = data.filter(data.searchTerm, data.options) || []
    }

    if (opts.length > data.maxFilteringResults) {
      // Filtering select and there's too many nodes, we're not going
      // to show any results. They need to keep typing to narrow it down
      opts = []
    }
  }

  // If it's a multi select, we don't show options that have been selected
  if (data.multiple) {
    opts = opts.filter(function (opt) {
                return !opt.selected
               })
  }

  // If they set a groupBy, we don't respect the native select options, or the incoming options sort order
  if (data.groupBy) {
    opts = nest().key(function (d) {
                   return d[data.groupBy]
                 })
                 .entries(opts)
                 .reduce(function (p, c) {
                   return p.concat(c.values)
                 }, [])
  }

  // If it's creatable and they have typed in a search term, add the creatable option
  var creatable = buildCreatable(data.searchTerm, data)
  if (creatable) {
    var last = data.menuOptions && data.menuOptions[data.menuOptions.length - 1] || {}

    if (last.creatable) {
      data.menuOptions.pop()
    }

    opts.push(creatable)
  }

  // If the menu is open and something happened that is a candidate for selecting a default highlighted
  // option
  if (data.open && highlightable) {
    // If the menu is open, let's see if we should highlight an option
    var highlighted = opts.filter(function (o) {
                                    return o.highlighted
                                  })

    // If we don't have a highlighted option
    // and it's not a combo select (combo selects can only be highlighted by user interactions)
    if (!highlighted.length && !data.combo) {
      var selected = opts.filter(function (o) {
                            return o.selected
                          })

      // Highlight the selected option if there is one selected
      if (selected.length === 1) {
        selected[0].highlighted = true
      }

      // Nothing is selected, highlight the first option
      if (selected.length === 0 && opts.length > 0) {
        opts[0].highlighted = true
      }
    }
  }

  return opts
}
